import React from "react";
import styles from "./TranscriptTableHeader.module.css";

export const TranscriptTableHeader: React.FC = () => {
    return <div className={styles.wrapper}>
        <span className={styles.chunnelCell}>Channel</span>
        <span className={styles.customerCell}>Customer</span>
        <span className={styles.dateTimeCell}>Date & Time</span>
        <span className={styles.contactInformationCell}>Contact Information</span>
        <span className={styles.chatOutcomeCell}>Chat Outcome</span>
        <span className={styles.followUpCell}>Follow Up</span>
    </div>
}
